import { Component, Input, Output, EventEmitter } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { ExternalPredictorGroupGames, ExternalTriviaGroupGames, ExternalPollGroupGames } from '@fgb/core';

@Component({
  selector: 'fgb-submission-form',
  templateUrl: './submission-form.component.html',
  styleUrls: ['./submission-form.component.scss']
})
export class SubmissionFormComponent {
  @Input() gameDetails: ExternalTriviaGroupGames | ExternalPollGroupGames | ExternalPredictorGroupGames;
  @Input() unauthorizedForm: FormGroup;
  @Input() unauthorizedEntityCreated: boolean = false;
  @Input() isFormSubmitting: boolean = false;
  @Input() registrationWizardRoute: string = 'new-member';
  @Input() loginRoute: string = 'login'

  @Output() submitForm = new EventEmitter<void>();

  termsAccepted: boolean = false;

  constructor(
    private router: Router
  ) {}

  onSubmit(): void {
    this.submitForm.emit();
  }

  navigateToLogin(){
    this.router.navigate([`/${this.loginRoute}`])
  }

  navigateToRegistration(){
    let unauthorizedEntityGuid = sessionStorage.getItem('UnauthorizedEntityGuid')
    if(unauthorizedEntityGuid != null){
      this.router.navigateByUrl(`/register/${this.registrationWizardRoute}?unauthorizedEntityGuid=${unauthorizedEntityGuid}`)
    }
  }
}

